import Quill from "quill";
import { Picker } from "emoji-mart";

class EmojiHandler {
  quill: Quill;
  handler: string;
  range: any;
  id: number;
  options: {
    icons: {
      emoji: string;
    };
  };
  y: number = 0;

  constructor(
    quill: Quill,
    options: {
      icons: {
        emoji: string;
      };
    }
  ) {
    // save the quill reference
    this.quill = quill;
    this.handler = "emoji";
    this.range = this.quill.getSelection();
    this.id = 0;
    this.options = options;
    this.applyForToolbar();
  }

  attachmentIconHTML() {
    return `<img src="${this.options.icons.emoji}"  alt="emoji icon"/>`;
  }

  appendAttachmentIcon(toolbar) {
    const toolbarContainer = toolbar.container;
    const _elements = toolbarContainer.getElementsByClassName("ql-emoji");

    const style = document.createElement("style");
    style.appendChild(
      document.createTextNode("svg .file-toolbar:hover{ fill: #0065cc }")
    );

    if (_elements.length > 0) {
      let node = document.createElement("svg");
      node.innerHTML = this.attachmentIconHTML();

      const _element = _elements[0];
      if (!_element) return;

      if (_element?.children.length <= 0) {
        _element.appendChild(style);
        _elements[0].appendChild(node);
      }
    }
  }

  applyForToolbar() {
    const toolbar = this.quill.getModule("toolbar");

    this.appendAttachmentIcon(toolbar);

    const container: HTMLElement = document.querySelector(
      ".ql-emoji"
    );

    if(!container) return

    const emojiTag = document.createElement("div");

    emojiTag.className = "emoji-tag";
    emojiTag.style.position = "relative";

    if(container) {
      container.appendChild(emojiTag)
    }

    // if (toolbar)
    //   toolbar.addHandler(this.handler, this._handlerFn.bind(this));

    if (toolbar) {

      const toolbarContainer = toolbar.container.querySelector('.ql-emoji');

      toolbarContainer.querySelector("svg").addEventListener('click', this.handlerFn.bind(this))

    }

  }

  handlerFn($event) {
    this.range = this.quill.getSelection();

    console.log("Con", $event)

    const emojiTag: HTMLElement = document.querySelector(
      ".emoji-tag"
    );

    let emojiPickerElement = this.getEmojiPickerElement();

    // if emoji-embed exist remove
    if (emojiPickerElement) {

      emojiTag.removeChild(emojiPickerElement);

    } else {

      emojiPickerElement = this.createEmojiPickerElement()

      emojiTag.appendChild(emojiPickerElement);

      this.createPickerInstance(emojiPickerElement)

    }

  }

  createPickerInstance(parent: HTMLElement) {

    return new Picker({
      autoFocus: true,

      theme: "light",
      parent,
      navPosition: "down",

      onEmojiSelect: (emoji: { native: string; }) => {

        this.insertBase64Data(emoji.native)

        this.closeEmojiPanel()

      },

      onClickOutside: () => {

      }


    })
  }

  createEmojiPickerElement() {
    const div = document.createElement('div');

    div.classList.add('emoji-picker', 'emoji-picker-embed');

    div.style.position = 'absolute';
    div.style.zIndex = '90000';
    div.style.right = '100%';
    div.style.top = '0';

    return div;
  }

  getEmojiPickerElement() {

    return document.querySelector('.emoji-picker-embed') as HTMLElement

  }

  closeEmojiPanel() {

    const emojiTag: HTMLElement = document.querySelector(
      ".emoji-tag"
    );

    const htmlEl = document.querySelector(".emoji-picker-embed")

    // check there is no open htmlContainer
    if (htmlEl) {
      emojiTag.removeChild(htmlEl);
    }

  }
  insertBase64Data(emoji: string) {
    const range = this.range; //this.quill.getSelection();
    let rangeIndex = range?.index || 0

    if(rangeIndex == 0 && this.quill.getLength() > 1) {
      rangeIndex = this.quill.getLength() - 1
    }

    this.quill.insertText(rangeIndex, emoji);
  }

}

export default EmojiHandler;
